<template>
  <div class="chart-wrap">
    <Echart
      :options="options"
      id="centreLeft1Chart"
      height="100%"
      width="100%"
    ></Echart>
  </div>
</template>

<script>
import Echart from "@/common/echart";

export default {
  components: {
    Echart,
  },
  props: {
    cdata: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      options: {},
    };
  },
  watch: {
    cdata: {
      handler(newData) {
        const source = Array.isArray(newData?.seriesData) ? newData.seriesData : [];
        let total = source.reduce((sum, item) => sum + Number(item?.value || 0), 0);

        const info = JSON.parse(localStorage.getItem("userInfo") || "{}");
        if (info.customerId === 252) {
          total = 75369;
        }

        this.options = {
          title: {
            text: String(total),
            left: "center",
            top: "43%",
            textStyle: {
              fontWeight: "bold",
              fontSize: 14,
              color: "#00cdff",
            },
          },
          color: [
            "#37a2da",
            "#6871d0",
            "#4d9f88",
            "#ffdb5c",
            "#006de6",
            "#00d2f5",
            "#e7bcf3",
            "#8378ea",
          ],
          tooltip: {
            trigger: "item",
            formatter: "{b}: {c}件 ({d}%)",
          },
          legend: {
            orient: "horizontal",
            icon: "circle",
            bottom: 10,
            left: "center",
            width: "100%",
            data: newData?.xData || [],
            itemWidth: 6,
            itemHeight: 6,
            itemGap: 4,
            textStyle: {
              color: "#fff",
              fontSize: 10,
            },
          },
          series: [
            {
              name: "",
              type: "pie",
              avoidLabelOverlap: true,
              radius: ["30%", "55%"],
              center: ["50%", "50%"],
              data: source,
              label: {
                show: true,
                color: "#fff",
                fontSize: 12,
                formatter(params) {
                  return `${Number(params?.percent || 0).toFixed(0)}% ${Number(params?.value || 0)}件`;
                },
              },
              labelLine: {
                length: 10,
                length2: 14,
                lineStyle: {
                  width: 1,
                },
              },
            },
          ],
        };

        if (this.$screenWidth >= 1520) {
          this.options.title.textStyle.fontSize = 16;
          this.options.legend.textStyle.fontSize = 14;
          this.options.legend.bottom = 16;
          this.options.series[0].radius = ["24%", "50%"];
          this.options.series[0].label.fontSize = 14;
        } else if (this.$screenWidth >= 1400 && this.$screenWidth < 1520) {
          this.options.title.textStyle.fontSize = 14;
          this.options.legend.textStyle.fontSize = 12;
          this.options.legend.bottom = 12;
          this.options.series[0].radius = ["24%", "46%"];
          this.options.series[0].label.fontSize = 12;
        }
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.chart-wrap {
  width: 100%;
  height: 100%;
}
</style>

